import * as i0 from "@angular/core";
var FormErrorHandler = /** @class */ (function () {
    function FormErrorHandler() {
    }
    FormErrorHandler.prototype.hasError = function (form, controlName, errorCode) {
        var control = form.get(controlName);
        var errors = control.errors;
        var error = errorCode && errors ? errors[errorCode] : null;
        return (errorCode ? error : !control.valid) && (control.dirty || control.touched);
    };
    FormErrorHandler.prototype.hasGroupError = function (form, errorCode) {
        var errors = form.errors;
        var error = errorCode && errors ? errors[errorCode] : null;
        return (errorCode ? error : !form.valid) && (form.dirty || form.touched);
    };
    FormErrorHandler.prototype.hasArrayError = function (form, parentName, index, controlName, errorCode) {
        var parent = form.get(parentName);
        var control = parent.at(index).get(controlName);
        var errors = control.errors;
        var error = errorCode && errors ? errors[errorCode] : null;
        return (errorCode ? error : !control.valid) && (control.touched);
    };
    FormErrorHandler.ngInjectableDef = i0.defineInjectable({ factory: function FormErrorHandler_Factory() { return new FormErrorHandler(); }, token: FormErrorHandler, providedIn: "root" });
    return FormErrorHandler;
}());
export { FormErrorHandler };
